/// <reference path="DOMAttached.js" />

var marBottom;
var height, width;

class GNOMListItem extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.behaviour = options.behaviour;
		this.link = options.link;
		this.locked = false;

		if (this.el.querySelector('.petImageContainer') && this.behaviour != 'None') {
			this.safeObserve(this.el.querySelector('.petImageContainer'), 'click', this.onClick.bind(this));
		} else if (this.el.querySelector('img') && this.behaviour != 'None') {
			this.safeObserve(this.el.querySelector('img'), 'click', this.onClick.bind(this));
		}
	}

	onClick(ev) {
		if (this.el.closest('.GNOMApplication') != undefined
			&& !this.el.closest('.GNOMApplication').querySelector('.tabbedApplication').attachedObj.blocked) {

			if (this.locked)
				return;

			if (this.el.closest('.GNOMPage') != undefined && this.el.closest('.GNOMPage').classList.contains('deactivated'))
				return;

			switch (this.behaviour) {
				case 'MultiSelect':
					if (this.el.classList.contains('selected')) {
						this.el.classList.remove('selected');
					} else {
						this.el.classList.add('selected');
					}
					break;
				case 'Popup':
					GenericSoundsInstance.pickUpSound();
					this.el.closest('.GNOMApplication').querySelector('.popupContainer').attachedObj.showPopup(this.link);
					break;
				case 'Link':
					GenericSoundsInstance.clickSound();
					this.el.closest('.tabbedApplication').attachedObj.loadPage(this.link);
					break;
				case 'CallbackSelect':
					if (this.el.classList.contains('shared'))
						this.el.classList.remove('shared');
					else
						this.el.classList.add('shared');

					var list = this.el.closest('.gnomList').attachedObj;
					this.locked = true;
					list.loadPage(list.options.currentPage, this.options.link.replace('PLH_switch', this.el.classList.contains('shared')));
					break;
				case 'Animation':
					this.el.closest('.GNOMApplication').querySelector('.animationContainer').attachedObj.loadAnimation(this.link, ev.clientX);
					break;
			}
		}
	}

	onLoadPage(pageEl) {
		this.locked = false;
	}

	onMouseOver(ev) {
		this.height = this.el.querySelector('img').height;
		this.width = this.el.querySelector('img').width;
		if (!this.el.closest('.GNOMApplication').querySelector('.tabbedApplication').attachedObj.blocked) {
			this.el.querySelector('img').style.width = (this.width + 7) + 'px';
			this.el.querySelector('img').style.height = (this.height + 7) + 'px';
			this.marBottom = this.window.getComputedStyle(el).getPropertyValue("marginBottom");
			if (this.marBottom == '18px') {
				this.el.style.marginBottom = '11px';
			}
		}
	}

	onMouseOut(ev) {
		this.el.querySelector('img').style.width = this.width + 'px';
		this.el.querySelector('img').style.height = this.height + 'px';
		this.el.style.marginBottom = this.marBottom;
	}
}
